import React, { useState, useEffect } from 'react'
import Modal from '@material-ui/core/Modal'
import { Typography } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from '../index'
import closeIcon from '../../../assetss/img/closeModalIcon.svg'
import c from 'classnames'
import { useStyles } from './style'

const Unsubscribe = ({ open, onClose, unsubscribeMail }) => {
  const history = useHistory()
  const classes = useStyles()
  const { pathname } = useLocation()
  const [sucsses, setSucsses] = useState(false)
  const [valuesModal, setValuesModal] = useState({
    title: 'Unsubscribe  from newsletter',
    desc: 'You will not receive newsletter with actual and usefull information about tellme anymore.',
  })

  useEffect(() => {
    if (pathname === '/unsubscribeFull') {
      setValuesModal({
        title: 'Unsubscribe  from meeting reminder',
        desc: 'If you unsubscribe from meeting notification we will not send you  date and time reminder anymore.',
      })
    }
  }, [pathname])

  return (
    <>
      <Modal className={classes.modalBack} open={open}>
        {sucsses ? (
          <div className={classes.paperSucsses}>
            <img
              src={closeIcon}
              className={classes.closeIcon}
              onClick={() => {
                history.push('/')
                onClose(false)
              }}
            />
            <Typography className={classes.title}>Sorry to see you go!</Typography>
            <Typography className={classes.subTitle}>You've successfully unsubscribed from our emails.</Typography>
            <Button
              onClick={() => {
                history.push('/')
                onClose(false)
              }}
              className={c(classes.btnRegister)}
            >
              Close
            </Button>
          </div>
        ) : (
          <div className={classes.paper}>
            <img
              src={closeIcon}
              className={classes.closeIcon}
              onClick={() => {
                history.push('/')
                onClose(false)
              }}
            />
            <Typography className={classes.title}>{valuesModal?.title}</Typography>
            <Typography className={classes.subTitle}>{valuesModal?.desc}</Typography>
            <Button
              onClick={() => unsubscribeMail(setSucsses)}
              className={c(classes.btnRegister)}
            >
              Unsubscribe
            </Button>
          </div>
        )}
      </Modal>
    </>
  )
}

export default Unsubscribe
